module.exports = __webpack_public_path__ + "img/IconResult.ab455068.png";